import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {finalize} from 'rxjs/operators';
import {AuthenticationService} from '../@shared/services/authentication.service';
import {untilDestroyed} from '../@core';
import {ActivatedRoute, Router} from '@angular/router';
import {MessageService} from 'primeng/api';
import {CacheService} from '../@shared/services/cache.service';
import {environment} from '../../environments/environment';
import {ImUserService} from '../@shared/services/im-user.service';
import {HttpClient} from '@angular/common/http';
import {CredentialsService} from '../@shared/services/credentials.service';
import {LoginDetailsService} from './login-details.service';


// tslint:disable-next-line:ban-types
declare const gtag: Function;

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    loginForm!: FormGroup;
    isLoading: boolean;

    constructor(
        private router: Router,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private authenticationService: AuthenticationService,
        private messageService: MessageService,
        private cacheService: CacheService,
        private imUserService: ImUserService,
        private http: HttpClient,
        private loginDetailsService: LoginDetailsService) {
    }

    ngOnInit(): void {
        this.createLoginForm();
        const signedUser = localStorage.getItem('credentials');
        if (signedUser) {
            this.router.navigate(['booking-summary']);
        }
    }

    // tslint:disable-next-line:use-lifecycle-interface
    ngOnDestroy() {
    }

    login() {
        this.isLoading = true;
        const login$ = this.authenticationService.login(this.loginForm.value);
        login$
            .pipe(
                finalize(() => {
                    this.loginForm.markAsPristine();
                }),
                untilDestroyed(this)
            )
            .subscribe(
                (credentials) => {
                    this.cacheService.cacheResponse('loggedInUser', credentials);
                    this.addGAScript();
                    // this.imUserService.getDetailedLoginUser(credentials.userId)
                    //     .subscribe((res) => {
                    //         this.loginDetailsService.setLoggedInUser(res);
                    //         console.log('res', res)
                    //         // this.cacheService.cacheResponse('detailedLoggedInUser', res);
                    //         this.http.get('http://ip-api.com/json').subscribe((value) => {
                    //             console.log(value);
                    //             this.cacheService.cacheResponse('userLocation', value);
                    //         });
                    //     });
                    this.isLoading = false;
                    this.router.navigate([this.route.snapshot.queryParams.redirect || 'booking-summary'], {replaceUrl: true});
                },
                (error) => {
                    this.isLoading = false;
                    this.messageService.add({
                        key: 'login-error',
                        severity: 'error',
                        summary: 'Login Failed',
                        detail: error?.message ? error?.message : error
                    });
                }
            );
    }

    addGAScript() {
        const gtagScript: HTMLScriptElement = document.createElement('script');
        gtagScript.async = true;
        gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + environment.gaTrackingId;
        document.head.prepend(gtagScript);
        // /** Disable automatic page view hit to fix duplicate page view count  **/
        gtag('config', environment.gaTrackingId, {
            send_page_view: false,
        });
        // 'custom_map': {'loggedInUser': 'loggedInUser'}
    }

    private createLoginForm() {
        // username: ["avana104556@avana.com", Validators.required],
        // password: ["secret", Validators.required],
        this.loginForm = this.formBuilder.group({
            username: ['', [Validators.required, Validators.email]],
            password: ['', Validators.required],
            remember: true,
        });
    }

}
